import EmployeeProfile from './EmployeeProfile';
import {useOutletContext} from 'react-router-dom';
import {Box} from '@mui/material';

const MyProfileEmployeeInformation = () => {
    const {data = {}, isLoading, staffPermissions} = useOutletContext();

    return <Box marginTop={2}>
        <EmployeeProfile data={data} isLoading={isLoading} staffPermissions={staffPermissions}/>
    </Box>;
};

export default MyProfileEmployeeInformation;
